import './table.scss';

import PropTypes from 'prop-types';
import React from 'react';

import { useCurrencies } from '../../hooks';
import { formatDate, getValue } from '../../utils';

const DataTable = ({ data, headers, isFetching, emptyDataComponent, rowClick, rowAction }) => {
  const { availableCurrencies } = useCurrencies();
  const isRowClickable = typeof rowClick === 'function';
  const formatCurrency = (id) => {
    let currency = availableCurrencies.find(({ value }) => value === id);
    return currency?.slug || '';
  };
  return (
    <>
      <table className="table">
        <thead>
          <tr>
            {headers && headers.map(({ name }) => <th key={name}>{name}</th>)}
            {rowAction && <th aria-label="actions" />}
          </tr>
        </thead>
        <tbody>
          {!isFetching &&
            data &&
            data.map((item, index) => (
              <tr
                key={`row-${index}`}
                className={isRowClickable ? 'table__row--clickable' : undefined}
                onClick={isRowClickable ? () => rowClick(item) : undefined}
              >
                {headers &&
                  headers.map(({ name, column, filter, currency }, headIndex) => (
                    <td data-column={`${name} :`} key={`column-${index}-${headIndex}`}>
                      {name === 'Dispute Type' && (
                        <span className={item[column]}>{item[column]}</span>
                      )}
                      {name === 'Status' && (
                        <span className={item[column].toLowerCase()}>{item[column]}</span>
                      )}
                      {filter === 'date'
                        ? formatDate(item, column)
                        : name !== 'Status' && name !== 'Dispute Type' && getValue(item, column)}
                      {currency && ' ' + formatCurrency(item[currency])}
                    </td>
                  ))}
                {rowAction && (
                  <td className="table__action" data-column="">
                    {rowAction(item)}
                  </td>
                )}
              </tr>
            ))}
          {isFetching && (
            <>
              <DataTableLoader headers={headers} />
              <DataTableLoader headers={headers} />
              <DataTableLoader headers={headers} />
              <DataTableLoader headers={headers} />
            </>
          )}
        </tbody>
      </table>
      {!isFetching &&
        !data.length &&
        (emptyDataComponent ? (
          emptyDataComponent
        ) : (
          <div className="table__empty">
            <p>No data available</p>
          </div>
        ))}
    </>
  );
};

DataTable.propTypes = {
  headers: PropTypes.array,
  data: PropTypes.array,
  emptyDataComponent: PropTypes.element,
  isFetching: PropTypes.bool,
  rowClick: PropTypes.func,
  rowAction: PropTypes.func
};

const DataTableLoader = ({ headers }) => {
  return (
    <>
      <tr>
        {headers.map(({ column }) => (
          <td className="loading" key={`loader-${column}`}>
            <div className="bar"></div>
          </td>
        ))}
      </tr>
    </>
  );
};

DataTableLoader.propTypes = {
  headers: PropTypes.array
};

export { DataTable };
